module.exports = __webpack_public_path__ + "images/1208390dabee6ac8dbb1c6371d9bf6e0.png";